import React from 'react';
import { IonItem, IonLabel, IonTextarea } from '@ionic/react';
import { MAX_BODY_LENGTH, visuallyHiddenInputStyle } from './constants';

interface EditableDetailsBlockProps {
  topicBody: string;
  setTopicBody: (value: string) => void;
  /** What the field is called, e.g. "Article" for news. */
  label?: string;
  placeholder?: string;
}

/**
 * Editable body field (markdown), with a hidden native mirror input —
 * the last body of `TopicBasicsBlock`'s card, so its row closes the card.
 */
const EditableDetailsBlock: React.FC<EditableDetailsBlockProps> = ({
  topicBody,
  setTopicBody,
  label = 'Body',
  placeholder = 'Enter topic body (markdown supported)',
}) => (
  <>
    <IonItem lines="none">
      <IonLabel position="stacked" className="topic-form-label">
        {label}
      </IonLabel>
      <IonTextarea
        value={topicBody}
        onIonInput={e => setTopicBody((e.detail.value as string) || '')}
        placeholder={placeholder}
        rows={8}
        maxlength={MAX_BODY_LENGTH}
        counter={true}
      />
    </IonItem>
    <input
      type="text"
      data-testid="topic-body-input"
      value={topicBody}
      onInput={e => setTopicBody((e.target as HTMLInputElement).value || '')}
      onChange={e => setTopicBody(e.target.value)}
      style={visuallyHiddenInputStyle}
      aria-hidden="true"
      tabIndex={-1}
    />
  </>
);

export default EditableDetailsBlock;
